import { render, staticRenderFns } from "./RequisitionsTable.vue?vue&type=template&id=2b5234ed&scoped=true&"
import script from "./RequisitionsTable.vue?vue&type=script&lang=ts&"
export * from "./RequisitionsTable.vue?vue&type=script&lang=ts&"
import style0 from "./RequisitionsTable.vue?vue&type=style&index=0&id=2b5234ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5234ed",
  null
  
)

export default component.exports